<template>
  <el-drawer title="用户信息详情" :visible.sync="visible" direction="rtl" size="68%" append-to-body :before-close="handleClose" custom-class="detail-drawer">
    <div v-loading="loading" class="drawer-content">
      <!-- 基本信息 -->
      <h4 class="section-header">基本信息</h4>
      <el-row :gutter="20" class="mb8">
        <el-col :span="24" >
          <div class="avatar-preview">
            <img class="author-avatar" :src="info.avatar" alt="">
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mb8">
        <el-col :span="12">
          <div class="info-item">
            <label class="info-label">用户昵称：</label>
            <span class="info-value plaintext">{{ info.nickname }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-item">
            <label class="info-label">登录账号：</label>
            <span class="info-value plaintext">{{ info.username }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mb8">
        <el-col :span="12">
          <div class="info-item">
            <label class="info-label">用户状态：</label>
            <span class="info-value plaintext">
              <el-tag size="small" :type="info.isDisable === 0 ? 'success' : 'danger'">{{ info.isDisable === 0 ? '正常' : '停用' }}</el-tag>
            </span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-item full-width">
            <label class="info-label">角色：</label>
            <span class="info-value plaintext">{{ info.roleName || '无角色' }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mb8">
        <el-col :span="12">
          <div class="info-item">
            <label class="info-label">邮箱：</label>
            <span class="info-value plaintext">{{ info.email }}</span>
          </div>
        </el-col>
      </el-row>
      <!-- 其他信息 -->
      <h4 class="section-header">其他信息</h4>
      <el-row :gutter="20" class="mb8">
        <el-col :span="12">
          <div class="info-item">
            <label class="info-label">登录类型：</label>
            <span class="info-value plaintext">{{ loginTypeLabel || '未知' }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-item">
            <label class="info-label">创建时间：</label>
            <span class="info-value plaintext">{{ info.createTime }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mb8">
        <el-col :span="12">
          <div class="info-item">
            <label class="info-label">最后登录IP：</label>
            <span class="info-value plaintext">{{ info.ipAddr }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-item full-width">
            <label class="info-label">最后登录地址：</label>
            <span class="info-value plaintext">{{ info.ipSource }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mb8">
        <el-col :span="24">
          <div class="info-item">
            <label class="info-label">最后登录时间：</label>
            <span class="info-value plaintext">{{ info.lastLoginTime }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-drawer>
</template>

<script>
import { getUser } from '@/api/system/user'

export default {
  name: 'UserViewDrawer',
  dicts: ['login_type'],
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      postOptions: [],
      roleOptions: []
    }
  },
  computed: {
    loginTypeLabel() {
      return this.selectDictLabel(this.dict.type.login_type, this.info.loginType) || '-'
    },
  },
  methods: {
    open(userId) {
      this.visible = true
      this.loading = true
      getUser(userId).then(res => {
        this.info = res.data || {}
      }).finally(() => {
        this.loading = false
      })
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>
